// 此文件由脚本自动生成，请勿直接修改。
// This file was generated automatically by a script. Please do not modify it directly.

import { BadgeTokens } from './type';

const badgeTokens: BadgeTokens = {
  badgeBadgeFontSize: 'Font-12',
  badgeBadgeFontColor: 'Neutral-text-1',
  badgeBadgeBackgroundColor: 'Danger-6',
  badgeBadgeBorderRadius: 'Radius-full',
  badgeCountPaddingX: 'Spacing-4',
  badgeCountHeight: 'Size-10',
  badgeSmallCountHeight: 'Size-8',
  badgeDotWidth: 'Size-3',
  badgeTextMarginLeft: 'Spacing-8',
  badgeTextFontColor: 'Neutral-text-5',
  badgeDefaultBackgroundColor: 'Neutral-fill-5',
  badgeWarningBackgroundColor: 'Warning-6',
  badgeSuccessBackgroundColor: 'Success-6',
  badgeErrorBackgroundColor: 'Danger-6',
  badgeProcessingBackgroundColor: 'Brand-6',
};

export default badgeTokens;
